import React from "react";
import { Pagination, Button } from "zina-dogi-react";
import { Link } from "react-router-dom";
import { service as vendorService } from "../redux";
import swal from "sweetalert";

const titles = ["Enterprise Name", "Vendor Status", "Synergy", "Vendor Code"];

const VendorsTable = ({ list, pagination, ...props }) => {
    const { className } = props;
    const vendorTable_op = {
        className: ["vendor_table", className].join(" ")
    };
    return (
        <div {...vendorTable_op}>
            <nav className="navbar">
                <span className="navbar-brand h4" />
                <div>
                    <Button
                        color="primary"
                        className="ml-1 mr-1"
                        onClick={() => {
                            vendorService.requestReport().then(data => {
                                if (data && data.detail) {
                                    swal({
                                        title: "Successfully!",
                                        text: data.detail,
                                        icon: "success",
                                        timer: 3000,
                                        button: true
                                    });
                                }
                            });
                        }}
                    >
                        Vendor Report
                    </Button>
                    <Link to="/vendor/importer" className="btn-success btn zina-btn ml-1 mr-1">
                        Add or Edit Suppliers
                    </Link>
                </div>
            </nav>
            <br />
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`cpo_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(list)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = list => {
    const values = Object.values(list);
    if (values.length > 0) {
        return values.map((vendor, i) => {
            return (
                <tr key={`vendor_${i}`}>
                    <td>{vendor.legal_name}</td>
                    <td>{vendor.cancelled ? "Cancelled" : "Active"}</td>
                    <td>
                        {vendor.sinergy !== null ? (vendor.sinergy ? "Synergy Partner" : "Non-Synergy Partner") : null}
                    </td>
                    <td>{vendor.vendor_number}</td>
                </tr>
            );
        });
    } else {
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    }
};

export default VendorsTable;
